var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-default-block-elements"
    },
    [
      _c("courseware-block-actions", {
        attrs: {
          block: _vm.block,
          canEdit: _vm.canEdit
        },
        on: {
          editBlock: _vm.editBlock,
          showExportOptions: _vm.showExportOptions
        }
      }),
      _vm._v(" "),
      _vm.canEdit
        ? _c("courseware-block-feedback", {
            attrs: {
              block: _vm.block,
              canEdit: _vm.canEdit,
              isTeacher: _vm.isTeacher
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("courseware-block-comments", {
        attrs: {
          block: _vm.block
        }
      }),
      _vm._v(" "),
      _vm.canEdit
        ? _c("courseware-block-export-options", {
            attrs: {
              block: _vm.block
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }